module.exports = __webpack_public_path__ + "img/ccmpr3.f114501c.jpg";